import React, { useEffect, useState } from "react";
import useGetRequest from "../../hooks/useGetRequest";
import { ICompany } from "../../types/company.type";
import { Card, Spin, Alert, Input, Button, Form, Modal, message } from "antd";
import { api } from "../../api/api";

export default function Company() {
  const { data, loading, error } = useGetRequest("/settings/company");
  const [company, setCompany] = useState<ICompany | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (data?.company) {
      setCompany(data.company);
    }
  }, [data]);

  const updateCompany = async (values: ICompany) => {
    setIsLoading(true);

    try {
      let response;
      if (company) {
        response = await api.post("/settings/company", values);
      } else {
        response = await api.post("/settings/company", values);
      }

      setCompany(response.data.company);
      setIsModalVisible(false);
      message.success(
        company
          ? "Данные компании успешно обновлены!"
          : "Компания успешно добавлена!"
      );
    } catch (error) {
      message.error("Ошибка при обновлении данных.");
    } finally {
      setIsLoading(false);
    }
  };

  const openModal = () => {
    setIsEditing(!!company);
    setIsModalVisible(true);
  };

  if (error) {
    return <Alert message="Ошибка при загрузке данных" type="error" showIcon />;
  }

  if (loading) {
    return <Spin tip="Загрузка..." />;
  }

  return (
    <div>
      {company ? (
        <Card title="Данные компании" style={{ width: 500 }}>
          <p>
            <strong>Название:</strong> {company.name}
          </p>
          <p>
            <strong>Адрес:</strong> {company.address}
          </p>
          <p>
            <strong>Телефон:</strong> {company.phone}
          </p>
          <p>
            <strong>Владелец:</strong> {company.owner}
          </p>
          <Button type="primary" onClick={openModal} style={{ marginTop: 16 }}>
            Изменить
          </Button>
        </Card>
      ) : (
        <Card title="Компания не найдена" style={{ width: 500 }}>
          <Button type="primary" onClick={openModal}>
            Добавить компанию
          </Button>
        </Card>
      )}

      <Modal
        title={
          isEditing ? "Редактировать данные компании" : "Добавить компанию"
        }
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <Spin spinning={isLoading}>
          <Form
            initialValues={company || {}}
            onFinish={updateCompany}
            layout="vertical"
            style={{ maxWidth: 500 }}
          >
            <Form.Item
              label="Название"
              name="name"
              rules={[
                { required: true, message: "Пожалуйста, введите название!" },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Адрес"
              name="address"
              rules={[
                { required: true, message: "Пожалуйста, введите адрес!" },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Телефон"
              name="phone"
              rules={[
                { required: true, message: "Пожалуйста, введите телефон!" },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Владелец"
              name="owner"
              rules={[
                { required: true, message: "Пожалуйста, введите владельца!" },
              ]}
            >
              <Input />
            </Form.Item>
            <Button type="primary" htmlType="submit" loading={isLoading}>
              {isEditing ? "Обновить" : "Добавить"}
            </Button>
          </Form>
        </Spin>
      </Modal>
    </div>
  );
}
